
import { createActionSet } from '../utils/Utilities'
export const LOGIN = "LOGIN"
export const EBG_DETAIL = "EBG_DETAIL"
export const FECT_STEP = createActionSet("FECT_STEP")
export const NAVIGATION = "NAVIGATION"